import { render, staticRenderFns } from "./modalHistorialRecompensas.vue?vue&type=template&id=b505a24a&scoped=true"
import script from "./modalHistorialRecompensas.vue?vue&type=script&lang=js"
export * from "./modalHistorialRecompensas.vue?vue&type=script&lang=js"
import style0 from "./modalHistorialRecompensas.vue?vue&type=style&index=0&id=b505a24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b505a24a",
  null
  
)

export default component.exports